import React, { useState } from "react";
import HamburgerMenu from "./HamburgerMenu";
import pricingBackground from "./assets/pricingbackground.png";

export default function Pricing() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((open) => !open);

  return (
    <div
      className="min-h-screen text-white font-[Montserrat] flex flex-col bg-black sm:bg-transparent relative"
    >
      {/* Full background image on desktop only */}
      <div
        className="hidden sm:block absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${pricingBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Header Bar */}
      <nav className="flex justify-end items-center px-6 py-4 relative z-20">
        <div className="flex gap-3 items-center">
          <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
        </div>
      </nav>

      {/* Pricing Section */}
      <section className="w-full py-16 flex flex-col items-center relative z-10">
        <div className="rounded-2xl bg-black bg-opacity-80 p-10 w-full max-w-3xl text-white text-center">
          <h2 className="text-3xl font-extrabold mb-4 tracking-tight">Pricing</h2>

          {/* Mobile text */}
          <p className="text-lg mb-10 px-4 font-semibold sm:hidden">
            Each Submission = <strong>1 Credit</strong>
          </p>

          {/* Desktop text */}
          <p className="text-lg mb-10 px-4 font-semibold hidden sm:block">
            Each submission requires <strong>1 CREDIT</strong>.<br />
            Credits can be purchased in two different quantities:
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <div className="bg-white text-black rounded-2xl shadow-lg p-6 min-w-[220px] max-w-[280px]">
              <h3 className="text-xl font-bold mb-2">1 Credit</h3>
              <p className="text-lg font-semibold mb-2">$4.49</p>
            </div>

            <div className="bg-white text-black rounded-2xl shadow-lg p-6 min-w-[220px] max-w-[280px]">
              <h3 className="text-xl font-bold mb-2">5 Credits</h3>
              <p className="text-lg font-semibold mb-2">$14.99</p>
              <p className="text-sm text-green-600">Save ~33%</p>
            </div>
          </div>
        </div>

        <div className="mt-8 text-base text-white text-center">
          <p className="mb-3">
            Have grading experience? Apply{" "}
            <a
              href="https://forms.gle/example"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-blue-400"
            >
              here
            </a>.
          </p>
          <div className="text-sm text-gray-400 flex justify-center gap-2">
            <a href="/help" className="hover:underline">Help</a>
            <span>|</span>
            <a href="/terms" className="hover:underline">Terms of Service</a>
            <span>|</span>
            <a href="/contact" className="hover:underline">Contact</a>
          </div>
        </div>
      </section>
    </div>
  );
}
